module.exports = __webpack_public_path__ + "img/hudongyingxiao_1.494faf5e.png";